<template>
  <div id="offer-form" class="modal-form" v-if="formData">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <form class="formData-form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save &amp; Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
            <h1 class="form-title">Add/Edit Offer</h1>
            <fieldset>
              <legend>Basic information</legend>
              <div class="form-group row">
                <label for="title" class="form-label col-md-2"
                  >Offer Title*</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    v-model="formData.title"
                    required
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="description" class="form-label col-md-2"
                  >Description*</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="description"
                    rows="4"
                    v-model="formData.description"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="terms" class="form-label col-md-2"
                  >Terms &amp; Conditions:</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="terms"
                    rows="4"
                    v-model="formData.terms"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="startDate" class="form-label col-md-2"
                  >Start date</label
                >
                <div class="col-md-10">
                  <DateRangeControl v-model="formData.startDate" />
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="form-label col-md-2">End date</label>
                <div class="col-md-10">
                  <DateRangeControl v-model="formData.endDate" />
                </div>
              </div>
              <div class="form-group row">
                <label for="socialIdentifiers" class="form-label col-md-2"
                  >Hashtag</label
                >
                <div class="col-md-10">
                  <input
                    id="socialIdentifiers"
                    type="text"
                    class="form-control"
                    v-model="formData.socialIdentifiers"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="ctaLink" class="form-label col-md-2">URL</label>
                <div class="col-md-10">
                  <input
                    type="url"
                    class="form-control"
                    id="ctaLink"
                    v-model="formData.ctaLink"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Image</legend>
              <div>
                <ImageUploadButton
                  newColor="var(--campaign-color)"
                  ref="imageUploader"
                  :imageUrl="
                    formData && formData.thumbnailUrl
                      ? formData.thumbnailUrl
                      : ''
                  "
                  @clear="onClearUploadImage"
                />
              </div>
            </fieldset>
            <fieldset>
              <legend>PARTICIPATING EXPERIENCES</legend>
              <div class="form-group row">
                <label for="experiences" class="form-label col-md-2"
                  >Experiences</label
                >
                <div class="col-md-10">
                  <ExperiencePicker v-model="formData.experiences" />
                </div>
              </div>
            </fieldset>
            <EnwokeDeclarationFieldset
              v-model="formData.isAcceptedEnwokeAgreement"
              @delete="onDelete"
              contentName="offer"
            />
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save &amp; Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangeControl from "@/components/DateRangeControl";
import ImageUploadButton from "@/components/ImageUploadButton";
import ExperiencePicker from "@/components/ExperiencePicker";
import EnwokeDeclarationFieldset from "@/components/EnwokeDeclarationFieldset";
import _ from "lodash";

export default {
  name: "OfferForm",
  components: {
    DateRangeControl,
    ImageUploadButton,
    ExperiencePicker,
    EnwokeDeclarationFieldset,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      id: null,
      regions: [],
      districts: [],
      options: [
        { text: "Content with most 'Likes' wins", value: "most_likes" },
        { text: "Winner is determined by a jury", value: "select_by_jury" },
      ],
      options1: [
        { text: "Once", value: "once" },
        { text: "Daily", value: "daily" },
      ],
      options2: [
        { text: "Mondays", value: "monday" },
        { text: "Tuesdays", value: "tuesday" },
        { text: "Wednesday", value: "wednesday" },
        { text: "Thursdays", value: "thursday" },
        { text: "Fridays", value: "friday" },
        { text: "Saturdays", value: "saturday" },
        { text: "Sundays", value: "sunday" },
      ],
      formData: {
        id: null,
        isAcceptedEnwokeAgreement: true,
        title: "",
        description: "",
        terms: "",
        startDate: "",
        endDate: "",
        isDailyOffer: false,
        socialIdentifiers: "",
        ctaLink: "",
        mainImageUrl: "",
        thumbnailUrl: "",
        experiences: [],
        status: "PUBLISH",
      },
    };
  },
  computed: {
    id() {
      return this.content ? this.content.id : this.formData.id;
    },
  },
  mounted() {
    if (this.content) {
      this.prepare(this.content);
    }
  },
  methods: {
    prepare(content) {
      const formData = _.merge({}, content); // Create a copy.
      if (formData.experiences && formData.experiences.results) {
        formData.experiences = formData.experiences.results;
      }
      this.formData = formData;
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    onSubmit(ev) {
      ev.preventDefault();
    },
    saveAndPublish(ev) {
      this.save("PUBLISH");
    },
    saveDraft() {
      this.save("DRAFT");
    },
    saveDraftWithoutClosing() {
      this.save("DRAFT", false);
    },
    unpublish() {
      this.save("UNPUBLISH");
    },
    async save(status = "PUBLISH", closeAfterSave = true) {
      if (status === "PUBLISH" && !this.formData.isAcceptedEnwokeAgreement)
        return;

      if (!this.formData.title || this.formData.title.trim() === "") {
        this.formData.title = "Untitled";
      }

      this.formData.status = status;

      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.mainImageUrl = files[0].url;
        this.formData.thumbnailUrl = files[0].url;
      }

      let promise = null;
      let saveData = _.merge({}, this.formData); // Clone data for saving.

      // Re-shape experience for saving.
      if (saveData.experiences && saveData.experiences.length > 0) {
        saveData.experiences = saveData.experiences.map((it) => it.id);
      }

      if (this.id) {
        promise = this.$repo.offer.updateOffer(saveData);
      } else {
        promise = this.$repo.offer.createOffer(saveData);
      }

      promise
        .then((data) => {
          this.formData.id = data.id;
          if (closeAfterSave) {
            this.$toasted.show("Save data successfully.", {
              type: "success",
              duration: 3000,
              position: "bottom-right",
            });
            this.closeForm();
          }
        })
        .catch((err) => {
          console.error(err);
          if (closeAfterSave) {
            this.$toasted.show("Something went wrong.", {
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
          }
        });
    },
    async onDelete() {
      if (this.id) {
        await this.$repo.offer.deleteOffer(this.id);
        this.closeForm();
      }
    },
    onClearUploadImage() {
      this.formData.mainImageUrl = "";
      this.formData.thumbnailUrl = "";
    },
    onClickCloseButton(ev) {
      ev.preventDefault();
      this.closeForm();
    },
    closeForm() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
$main-color: #1da1f2;

#offer-form {
  .form-title {
    color: $main-color;
  }

  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }

  #experience-form .form-title {
    color: $main-color;
  }

  input[type="submit"].btn-primary {
    background-color: $main-color;
    border-color: $main-color;
  }

  .experience-picker .vue-tags-input .ti-tag,
  .experience-picker .vue-tags-input .ti-selected-item,
  .picker-control li.selected {
    background-color: $main-color;
    border-color: $main-color;
  }

  .form-check-label {
    font-size: 14px;
  }

  .form-control {
    border-radius: 0;
  }
}
</style>
